<!-- <div class="container mt-3 col-6">

    <div id="MainCarousel" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
            <li *ngFor="let image of ds_gallery; let i=index" data-target="#MainCarousel" attr.data-slide-to="{{i}}" class="{{ (i==0)? 'active': '' }} "></li>
        </ol>
        <div class="carousel-inner ">
            <div class="carousel-item" [ngClass]="{ 'active': i == 0 }" *ngFor="let image of ds_gallery; let i=index ">
                <img [src]="image.url " class="d-block w-100 " [alt]="image.name ">
                <div class="carousel-caption d-none d-md-block">
                    <p class="badge badge-dark" style="font-size: 1em;">{{ image.filename }}</p>
                </div>
            </div>
        </div>
    </div>

</div> -->

<ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
        <a (click)="showGallery = !showGallery" class="nav-link active" [ngClass]="{'active' : showGallery }" id="galeria-tab" data-toggle="tab" href="#galeria" role="tab" aria-controls="galeria" aria-selected="true">
            <i class="far fa-images"></i> Galeria
        </a>
    </li>
    <li class="nav-item" role="presentation">
        <a (click)="showGallery = !showGallery" class="nav-link" [ngClass]="{'active' : !showGallery }" id="upload-tab" data-toggle="tab" href="#upload" role="tab" aria-controls="upload" aria-selected="false">
            <i class="fas fa-file-upload"></i> Subir Imagenes
        </a>
    </li>
</ul>
<div class="tab-content" id="myTabContent" style="overflow-y: auto;">
    <div class="tab-pane fade show active" [ngClass]="{'show active' : showGallery }" id="galeria" role="tabpanel" aria-labelledby="galeria-tab">

        <!-- Galeria -->
        <div id="galeria" class="container mt-3">
            <div class="card-columns ">
                <div class="card" *ngFor="let image of ds_gallery ">
                    <img [src]="image.url" class="card-img-top" alt="image.name " width="300px " onError="this.src='assets/images/platillos/noimage.png'">
                    <div class="card-body ">
                        <h5 class="card-title ">{{ image.name }}</h5>
                        <p class="card-text ">
                            <span class="badge badge-pill badge-primary ">{{ image.filename }}</span>
                        </p>
                        <p class="card-text "><small class="text-muted ">{{ image.typefile }}</small></p>
                    </div>
                    <div class="card-footer text-center ">
                        <button class="btn btn-primary " (click)="seleccionarImagen(image) " data-dismiss="modal">
                            <i class="fas fa-check-square"></i> Seleccionar
                        </button>
                        <button class="btn btn-danger ml-2" (click)="borrarImagen(image) ">
                            <i class="far fa-trash-alt "></i> Borrar
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="ds_gallery?.length <= 0">
                <div class="alert alert-info text-center" style="font-size: 1.3em;">
                    <i class="fas fa-exclamation-circle"></i> No hay imágenes en la galería
                </div>
            </div>
        </div>
        <!-- ./Galeria-->
    </div>
    <div class="tab-pane fade" [ngClass]="{'show active' : !showGallery }" id="upload" role="tabpanel" aria-labelledby="upload-tab">

        <!-- Upload -->

        <div class="container mt-3 col-12">
            <div class="card">
                <div class="card-header">
                    <i class="fas fa-info-circle"></i> Haz clic y selecciona la imagen que deseas subir a la galería
                </div>
                <div class="card-body">
                    <form [formGroup]="archivoForm" (ngSubmit)="subirArchivo()">

                        <label class="file-label alert alert-info col text-center filebutton" style="font-size: 1em;" for="file"> 
                            <i class="far fa-file-image"></i> 
                                <span *ngIf="!nombreArchivo">
                                    Clic Aquí
                                </span>
                                <span *ngIf="nombreArchivo">
                                    Archivo Seleccionado <i class="fas fa-check"></i>
                                </span>
                            <div class="progress">
                                <div *ngIf="porcentaje > 0 && porcentaje < 100" class="progress-bar bg-danger progress-bar-striped" role="progressbar" [ngStyle]="{ 'width' : porcentaje + '%' }" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" max="100">{{porcentaje}}%</div>
                            </div>
                        </label>
                        <button *ngIf="nombreArchivo" class="btn btn-success btn-block btn-lg" [ngClass]="{'is-loading': porcentaje > 0 && porcentaje < 100}" [disabled]="!archivoForm.valid && (porcentaje > 0 && porcentaje < 100)">
                            <i class="fas fa-cloud-upload-alt"></i> Subir archivo <strong>{{ nombreArchivo }}</strong>
                        </button>
                        <input id="file" style="visibility:hidden;" type="file" formControlName="archivo" (change)="cambioArchivo($event)" accept="image/jpeg, image/png">
                    </form>
                </div>
            </div>
        </div>

        <!-- ./Upload -->

    </div>
</div>